import { Examples } from '@/types';

export const ExampleMStoreColumnConfigurationRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
        {
          ...Examples.ExampleMStoreColumnConfiguration,
          components: {
            default: () =>
              import(
                /* webpackChunkName: "ExampleMStoreColumnReorder" */

                '@/views/examples/ExampleMStoreColumnReorder.vue'
              )
          }
        }
      ]
    : [];
